import { StateEffect, StateField } from "@codemirror/state";
import { Decoration, EditorView, WidgetType } from "@codemirror/view";

export interface GhostSuggestion { readonly position: number; readonly text: string }
export const setGhostSuggestion = StateEffect.define<GhostSuggestion | null>();

class GhostWidget extends WidgetType {
  constructor(readonly text: string) { super(); }
  override eq(other: GhostWidget): boolean { return this.text === other.text; }
  override toDOM(): HTMLElement {
    const span = document.createElement("span");
    span.className = "writing-ghost";
    span.textContent = this.text;
    span.setAttribute("aria-hidden", "true");
    return span;
  }
}

export const ghostSuggestion = StateField.define<GhostSuggestion | null>({
  create: () => null,
  update(value, transaction) {
    if (transaction.docChanged || transaction.selection) value = null;
    for (const effect of transaction.effects) {
      if (effect.is(setGhostSuggestion)) {
        const next = effect.value;
        const selection = transaction.state.selection.main;
        value = next && selection.empty && next.position === selection.head ? next : null;
      }
    }
    return value;
  },
  provide: (field) => EditorView.decorations.from(field, (value) => value
    ? Decoration.set([Decoration.widget({ widget: new GhostWidget(value.text), side: 1 }).range(value.position)])
    : Decoration.none),
});
